import useSWRImmutable from 'swr/immutable';

import config from '@/core/config/config';
import { REFERRAL_CODE } from '@/graphql/queries/apps';
import { customFetcher, getGqlString } from '@/utils/customFetcher';

const getReferralCodeQueryFetcher = () => {
  return customFetcher(config.APPS_SERVER, {
    query: getGqlString(REFERRAL_CODE),
  });
};

export const useReferralCodeQuery = () => {
  const { data, error, isLoading } = useSWRImmutable(REFERRAL_CODE, {
    fetcher: getReferralCodeQueryFetcher,
  });
  return { data: data?.data?.marketingReferralFromSessionAndValidate, error, isLoading };
};

// Commenting out because OB v2 seems to have handled cookie setting
// in the backend, but leaving in case that is no longer a valid solution
// for any reason and we need to set the cookie in the frontend.

// export const useReferralCodeSetInCookie = () => {
//   const referralCode = getReferralCodeFromURL();
//   const [cookies, setCookie] = useCookies();

//   if (referralCode && !cookies.REFERRAL_ID) {
//     setCookie('REFERRAL_ID', referralCode, { path: '/', maxAge: 2592000 });
//   }
// };
